import buildAds from '../../server/misc/cars-iso-vdp-ad-helper';

function photoLightboxService ($document, $timeout, alsService) {
    const DEFAULT_OPTIONS = {
        tabId: 'photos',
        photoIndex: 0
    };

    let photoLightboxService = {
        setOptions,
        getOptions,
        setBodyScroll,
        getAd,
        getVideoUrl
    };

    function setOptions (options = DEFAULT_OPTIONS) {
        photoLightboxService.options = options;
    }

    function getOptions () {
        return photoLightboxService.options || DEFAULT_OPTIONS;
    }

    function fireAlsImpression (data) {
        const alsObj = _buildAlsImpression(data);
        alsService.impression(alsObj);
    }

    function _buildAlsImpression (listing) {
        const alsKeys = [ "affiliateAgentId", "listingId", "localOfferId", "makeId", "modelId",
            "modelYearId", "primaryFeedSourceId", "sellerId", "stockTypeCode", "trimId" ];
        let alsObj = { };
        alsObj.pageToId = 2180;
        alsKeys.forEach(k => alsObj[k] = listing[k]);
        return alsObj;
    }

    function setBodyScroll (data, listing) {
        if (data === 'video') {
            fireAlsImpression(listing);
        }
        $timeout($document.find('body').addClass('cui-overlay-scroll-locked'), 100);
    }

    function getAd (listing) {

        const context = {
            listingDto: listing,
        };

        return buildAds('vdp.photo', context);
    }

    function getVideoUrl (url) {
        let embedLink = 'https://www.youtube.com/embed/';
        let videoId = getYouTubeId(url);

        if (videoId && !(url.indexOf('embed') > 0)) {
            url = embedLink + videoId;
        }

        return url;
    }

    return photoLightboxService;

    ////////////////////////////////////////////////////////////////////////////////////////////////

    function getYouTubeId (url) {
        if (url.indexOf('youtu') > 0) {
            return url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/)[1];
        }
    }
}

photoLightboxService.$inject = [
    '$document',
    '$timeout',
    'alsService'
];

export default photoLightboxService;
